import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {useState} from "react";
import {Comment} from "@mui/icons-material";
import {DialogContent, DialogTitle, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useAlternative} from "../alternative/Alternative";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {useSnackbar} from "../../../../misc/Snackbar";
import {Alternative} from "../../../../api/QuoteAlternatives";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useAlternative2} from "../alternative/AlternativeContext";

export function KeyingNotes() {
    const [show, setShow] = useState(false);
    const alt = useAlternative2();

    return (
        <>
            <SmallGreyButton startIcon={<Comment color={!!alt?.keyingNotes ? "primary" as "primary" : undefined} />} onClick={() => setShow(true)}>Keying Notes</SmallGreyButton>
            {show && <KeyingNotesModal onClose={() => setShow(false)} />}
        </>
    )
}

export function KeyingNotesModal(props: {
    onClose: () => void;
}) {
    const alt = useAlternative();
    const proj = useProjectId();
    const [value, setValue] = useState("");

    const loading = useAsync2(async (input) => {
        const list = await api.quoteAlternatives.list({
            project: input.project,
        });

        const alt = list.data.find(a => a.id === input.alternative);
        if(!alt) throw new Error("couldn't find alternative");

        setValue(alt.keyingNotes || "");
        return alt;
    },
        {alternative: alt, project: proj},
        [alt, proj]);

    const snack = useSnackbar();
    const onCloseRef = useSyncedRef(props.onClose);
    const update = useAsyncAction(async (input: Alternative) => {

        try {
            snack.loading();
            await api.quoteAlternatives.upsert(input)
        } finally {
            snack.hide();
        }

        snack.success("Updated");
        onCloseRef.current();
    }, []);

    const submit = () => {
        update.callback({
            ...loading.result as any,
            keyingNotes: value,
        });
    };

    return (
        <Dialog2 open onClose={props.onClose} onEnterPress={submit} fullWidth maxWidth="sm">
            <DialogTitle>
                Keying Notes
            </DialogTitle>
            <DialogContent>
                {loading.LoadingOrErrorElement}
                <TextField
                    multiline minRows={4}
                    fullWidth
                    value={value}
                    onChange={e => setValue(e.target.value)}
                />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={props.onClose}
                onSubmit={submit}
            />
        </Dialog2>
    )
}